module.exports = __webpack_public_path__ + "static/img/work-idea-img2.fd3e951.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/work-idea-img2.jpg
// module id = 7/Pq
// module chunks = 1